import type { Level } from '.';
import { Milestone, MilestoneEvolution } from './level.ruleset';

export const levelModifiers = (Level: Pick<Level, 'ruleset'>) => ({
  level,
  inventory,
}: Level.MutableState) => ({
  incrementXp(milestone: Milestone, petStage: MilestoneEvolution) {
    const { milestoneXp, requiredXp } = Level.ruleset;

    // Calculate total amount of XP.
    const xpGrant = milestoneXp(milestone, petStage);
    let newXp = xpGrant + level.xp;

    let levelDiff = 0;
    // Level up as many levels as possible.
    while (newXp >= requiredXp(level.current)) {
      // Decrease XP by the amount of XP required to level up.
      newXp -= requiredXp(level.current);

      // Level up.
      level.current++;
      levelDiff++;
    }

    // The remaining XP is carried over to the current level.
    level.xp = newXp;

    const events: Event[] = [
      {
        eventType: 'XPGrant',
        eventProperties: {
          xp: xpGrant,
          feature: milestone,
          $subFeature: milestone === 'debut' ? 'n/a' : petStage,
        },
      },
    ];

    if (levelDiff > 0) {
      events.push({
        eventType: 'PlayerLevelUp',
        eventProperties: {
          oldLevel: level.current - levelDiff,
          newLevel: level.current,
        },
      });
    }

    return events;
  },

  claimLevelRewards() {
    const { current, lastLevelReward } = level;
    const levelDiff = current - lastLevelReward;

    // No rewards to claim.
    if (levelDiff <= 0) return;

    // Award level up reward.
    inventory.points += Level.ruleset.levelUpReward(lastLevelReward, current);
    // Set last level reward to current level.
    level.lastLevelReward = current;
  },
});

type Event = {
  /** Defaults to current user ID. */
  userId?: string;
  eventType: string;
  eventProperties: {
    [key: string]: unknown;
  };
  userProperties?: {
    [key: string]: unknown;
  };
};
